import { createReducer, on } from '@ngrx/store';
import {
  buildDocumentPlaybookComplianceScores,
  getDocumentPlaybookComplianceScores,
} from '../models/documents.model';
import { DocumentsActions } from './actions';
import { initialState } from './state';

export const featureReducer = createReducer(
  initialState,
  on(DocumentsActions.setDocuments, (state, { documents }) => ({
    ...state,
    documents: documents,
    loadingDocuments: false,
  })),
  on(DocumentsActions.uploadSelectedDocumentFile, (state, { requestKey }) => ({
    ...state,
    selectedDocumentFileId: null,
    selectedDocumentFileUploadError: null,
    selectedDocumentFileUploadRequestKey: requestKey,
    selectedDocumentFileUploading: true,
  })),
  on(DocumentsActions.uploadSelectedDocumentFileSuccess, (state, { fileId, requestKey }) => {
    if (state.selectedDocumentFileUploadRequestKey !== requestKey) {
      return state;
    }

    return {
      ...state,
      selectedDocumentFileId: fileId,
      selectedDocumentFileUploadError: null,
      selectedDocumentFileUploading: false,
    };
  }),
  on(DocumentsActions.uploadSelectedDocumentFileFail, (state, { errorMessage, requestKey }) => {
    if (state.selectedDocumentFileUploadRequestKey !== requestKey) {
      return state;
    }

    return {
      ...state,
      selectedDocumentFileId: null,
      selectedDocumentFileUploadError: errorMessage,
      selectedDocumentFileUploading: false,
    };
  }),
  on(DocumentsActions.clearSelectedDocumentFileUpload, (state, {}) => ({
    ...state,
    selectedDocumentFileId: null,
    selectedDocumentFileUploadError: null,
    selectedDocumentFileUploadRequestKey: null,
    selectedDocumentFileUploading: false,
  })),
  on(DocumentsActions.loadDocuments, (state, {}) => ({
    ...state,
    loadingDocuments: true,
  })),
  on(DocumentsActions.loadDocumentsFail, (state, {}) => ({
    ...state,
    loadingDocuments: false,
  })),
  on(DocumentsActions.createDocument, (state, { model }) => ({
    ...state,
    uploadingDocumentData: model,
    creatingDocument: true,
    closeCreatingDocumentModal: false,
  })),
  on(DocumentsActions.createDocumentCancel, (state, {}) => ({
    ...state,
    uploadingDocumentData: null,
    selectedDocumentFileId: null,
    selectedDocumentFileUploadError: null,
    selectedDocumentFileUploadRequestKey: null,
    selectedDocumentFileUploading: false,
    creatingDocument: false,
    closeCreatingDocumentModal: false,
  })),
  on(DocumentsActions.createDocumentSuccess, (state, {}) => ({
    ...state,
    uploadingDocumentData: null,
    selectedDocumentFileId: null,
    selectedDocumentFileUploadError: null,
    selectedDocumentFileUploadRequestKey: null,
    selectedDocumentFileUploading: false,
    creatingDocument: false,
    closeCreatingDocumentModal: false,
  })),
  on(DocumentsActions.createDocumentFail, (state, {}) => ({
    ...state,
    uploadingDocumentData: null,
    selectedDocumentFileId: null,
    selectedDocumentFileUploadError: null,
    selectedDocumentFileUploadRequestKey: null,
    selectedDocumentFileUploading: false,
    creatingDocument: false,
    closeCreatingDocumentModal: false,
  })),
  on(DocumentsActions.startUploadingDocumentVersion, (state, { data }) => ({
    ...state,
    uploadingDocumentVersionData: data,
  })),
  on(DocumentsActions.completeUploadingDocumentVersion, (state, {}) => ({
    ...state,
    uploadingDocumentVersionData: null,
  })),
  on(DocumentsActions.createDocumentCancelled, (state, {}) => ({
    ...state,
    uploadingDocumentData: null,
    selectedDocumentFileId: null,
    selectedDocumentFileUploadError: null,
    selectedDocumentFileUploadRequestKey: null,
    selectedDocumentFileUploading: false,
    closeCreatingDocumentModal: true,
  })),
  on(DocumentsActions.closeCreatingDocumentModal, (state, {}) => ({
    ...state,
    closeCreatingDocumentModal: true,
  })),
  on(DocumentsActions.clearCreateDocumentCancelled, (state, {}) => ({
    ...state,
    closeCreatingDocumentModal: false,
  })),
  on(DocumentsActions.deleteDocument, (state, {}) => ({
    ...state,
    deletingDocument: true,
  })),
  on(DocumentsActions.deleteDocumentCancel, (state, {}) => ({
    ...state,
    deletingDocument: false,
  })),
  on(DocumentsActions.deleteDocumentSuccess, (state, {}) => ({
    ...state,
    deletingDocument: false,
  })),
  on(DocumentsActions.deleteDocumentFail, (state, {}) => ({
    ...state,
    deletingDocument: false,
  })),
  // on(DocumentsActions.deleteDocuments, (state, {}) => ({
  //   ...state,
  //   deletingDocuments: true,
  // })),
  // on(DocumentsActions.deleteDocumentsCancel, (state, {}) => ({
  //   ...state,
  //   deletingDocuments: false,
  // })),
  // on(DocumentsActions.deleteDocumentsSuccess, (state, {}) => ({
  //   ...state,
  //   deletingDocuments: false,
  // })),
  // on(DocumentsActions.deleteDocumentsFail, (state, {}) => ({
  //   ...state,
  //   deletingDocuments: false,
  // })),
  on(DocumentsActions.setDocument, (state, { document }) => ({
    ...state,
    document: document,
    loadingDocument: false,
  })),
  on(DocumentsActions.loadDocument, (state, {}) => ({
    ...state,
    loadingDocument: true,
  })),
  on(DocumentsActions.loadDocumentFail, (state, {}) => ({
    ...state,
    loadingDocument: false,
  })),
  on(DocumentsActions.editDocument, (state, {}) => ({
    ...state,
    editingDocument: true,
    closeEditingDocumentModal: false,
  })),
  on(DocumentsActions.editDocumentCancel, (state, {}) => ({
    ...state,
    editingDocument: false,
    closeEditingDocumentModal: false,
  })),
  on(DocumentsActions.editDocumentSuccess, (state, { document }) => ({
    ...state,
    document,
    editingDocument: false,
    closeEditingDocumentModal: false,
  })),
  on(DocumentsActions.editDocumentFail, (state, {}) => ({
    ...state,
    editingDocument: false,
    closeEditingDocumentModal: false,
  })),
  on(DocumentsActions.editDocumentCancelled, (state, {}) => ({
    ...state,
    document: null,
    closeEditingDocumentModal: true,
  })),
  on(DocumentsActions.closeEditingDocumentModal, (state, {}) => ({
    ...state,
    document: null,
    closeEditingDocumentModal: true,
  })),
  on(DocumentsActions.clearEditDocumentCancelled, (state, {}) => ({
    ...state,
    closeEditingDocumentModal: false,
  })),
  on(DocumentsActions.sendReport, (state, { report, doc }) => ({
    ...state,
    sendingReport: true,
    sendingReportDocument: doc,
    closeSendingReportModal: false,
  })),
  on(DocumentsActions.sendReportCancel, (state, {}) => ({
    ...state,
    sendingReport: false,
    closeSendingReportModal: false,
  })),
  on(DocumentsActions.startAskingReportStatus, (state, {}) => ({
    ...state,
    askingReportStatus: true,
  })),
  on(DocumentsActions.sendReportCompleteSuccess, (state, {}) => ({
    ...state,
    sendingReport: false,
    askingReportStatus: false,
  })),
  on(DocumentsActions.sendReportCompleteFailed, (state, {}) => ({
    ...state,
    sendingReport: false,
    askingReportStatus: false,
  })),
  on(DocumentsActions.sendReportCancelled, (state, {}) => ({
    ...state,
    closeSendingReportModal: true,
  })),
  on(DocumentsActions.closeSendingReportModal, (state, {}) => ({
    ...state,
    closeSendingReportModal: true,
  })),
  on(DocumentsActions.clearSendReportCancelled, (state, {}) => ({
    ...state,
    closeSendingReportModal: false,
  })),
  on(DocumentsActions.setSelectedDocumentPlaybook, (state, { uniqueId, assignedPlaybookId }) => ({
    ...state,
    selectedPlaybookIdByDocumentId: {
      ...state.selectedPlaybookIdByDocumentId,
      [uniqueId]: assignedPlaybookId,
    },
  })),
  on(DocumentsActions.startPageReview, DocumentsActions.pageReviewStarted, (state, { documentUniqueId }) => ({
    ...state,
    activePageReviewDocumentUniqueId: documentUniqueId,
    pageReviewProgressByDocumentId: {
      ...state.pageReviewProgressByDocumentId,
      [documentUniqueId]: {
        pageNumber: 0,
        totalPages: 0,
      },
    },
    pageReviewResponseDataByDocumentId: {
      ...state.pageReviewResponseDataByDocumentId,
      [documentUniqueId]: [],
    },
  })),
  on(DocumentsActions.pageReviewPageLoaded, (state, { documentUniqueId, pagedReviewData }) => {
    const existingClauses = getDocumentPlaybookComplianceScores(
      state.pageReviewResponseDataByDocumentId[documentUniqueId],
    ).flatMap((score) => score.clauses || []);

    return {
      ...state,
      pageReviewProgressByDocumentId: {
        ...state.pageReviewProgressByDocumentId,
        [documentUniqueId]: {
          pageNumber: pagedReviewData.pageNumber,
          totalPages: pagedReviewData.totalPages,
        },
      },
      pageReviewResponseDataByDocumentId: {
        ...state.pageReviewResponseDataByDocumentId,
        [documentUniqueId]: buildDocumentPlaybookComplianceScores([
          ...existingClauses,
          ...(pagedReviewData.clauses || []),
        ]),
      },
    };
  }),
  on(DocumentsActions.pageReviewComplete, (state, { documentUniqueId }) => {
    const { [documentUniqueId]: _, ...pageReviewProgressByDocumentId } =
      state.pageReviewProgressByDocumentId;

    return {
      ...state,
      activePageReviewDocumentUniqueId:
        state.activePageReviewDocumentUniqueId === documentUniqueId
          ? null
          : state.activePageReviewDocumentUniqueId,
      pageReviewProgressByDocumentId,
    };
  }),
  on(DocumentsActions.pageReviewFail, (state, { documentUniqueId }) => {
    const { [documentUniqueId]: _, ...pageReviewProgressByDocumentId } =
      state.pageReviewProgressByDocumentId;

    return {
      ...state,
      activePageReviewDocumentUniqueId:
        state.activePageReviewDocumentUniqueId === documentUniqueId
          ? null
          : state.activePageReviewDocumentUniqueId,
      pageReviewProgressByDocumentId,
    };
  }),
);
